import React from 'react';
import { Helmet as ReactHelmet } from 'react-helmet';
import { useI18next } from 'gatsby-plugin-react-i18next';

// Replacement component for the one provided by "gatsby-plugin-react-i18next" to remove the trailing slash from the URLs
// Source: https://github.com/microapps/gatsby-plugin-react-i18next/blob/master/src/Helmet.tsx
export default function Helmet({ children, ...props }) {
  const {
    languages,
    language,
    originalPath,
    defaultLanguage,
    siteUrl = '',
  } = useI18next();

  const createUrlWithLang = (lng) => {
    return `${siteUrl}${
      lng === defaultLanguage ? '' : `/${lng}`
    }${originalPath}`;
  };

  return (
    <ReactHelmet {...props}>
      <html lang={language} />
      <link rel="canonical" href={createUrlWithLang(language)} />
      {languages.map((lng) => (
        <link
          rel="alternate"
          key={lng}
          href={createUrlWithLang(lng)}
          hreflang={lng}
        />
      ))}
      {/* adding a fallback page for unmatched languages */}
      <link
        rel="alternate"
        href={createUrlWithLang(defaultLanguage)}
        hreflang="x-default"
      />
      {children}
    </ReactHelmet>
  );
}
